import {FormGroup, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';

import { HelperService } from '../helper.service';

export const bidAmountValidator: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
	const bidAmountValue = formGroup.get('bidAmount').value;
	const productId = formGroup.get('entity')?.value.productId;
	const units = formGroup.get('units').value?.text || '';
	const serviceTypeId = formGroup.get('serviceTypeId').value;
	const stateId = formGroup.get('stateId').value;

	if (!bidAmountValue) {
		return null;
	}

	if (isNaN(bidAmountValue)) {
		return { multipleDecimals: true };
	}

	const [minBidAmount, maxBidAmount] = [
		HelperService.getProductMinBidAmount(productId, serviceTypeId, units),
		HelperService.getProductMaxBidAmount(productId, serviceTypeId, stateId, units),
	];

	if (Number(bidAmountValue) <= Number(minBidAmount) || Number(bidAmountValue) >= Number(maxBidAmount)) {
		return { bidAmountMinMax: true };
	}

	return null;
};
